/**
 * 混合搜索
 * 
 * @Author: Focci
 * @Date: 2023-09-29 08:53:09
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-29 08:53:09
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useTranslations } from 'next-intl'
import { handleSearchItemClick } from './lib'
import CombineAutocomplete from './CombineAutocomplete'

export { handleSearchItemClick }

export default function Combine({
  value = [],
  onChange = () => {},
  wraperClassName = 'w-full',
  type,
  optionPrevFilter,
  autocompleteProps = {},
  children,
}) {
  const ts = useTranslations('search')

  return (
    <div className={clsx(['max-w-full flex', wraperClassName])}>
      <CombineAutocomplete
        value={value}
        type={type}
        onChange={onChange}
        optionPrevFilter={optionPrevFilter}
        placeholder={ts('searchInputPlaceholder')}
        {...autocompleteProps}
      />
      {children}
    </div>
  )
}

Combine.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  wraperClassName: PropTypes.string,
  autocompleteProps: PropTypes.object,
  children: PropTypes.node,
}
